import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';
import { Tab, Tabs } from 'react-bootstrap';
// import { fetchPrograms } from '../../../Nomination/NominationActions';
// import { fetchTVProductMappings } from '../../../Setup/SetupActions';
import NumberDisplay from '../../../../components/number-display';
import SearchForm from '../../../../components/search-form';
import ProgressBar from '../../../../components/progress-bar';
import IncludeOpenOpportunities from '../../components/include-open-opportunities';
import OpportunityTable from '../../../Analysic/components/table/opportunity-table';
import OpportunityModal from '../../../Analysic/components/opportunity-modal';
import ExclusionStats from './Stats';
import ExcludeOpportunityForm from '../../components/opportunity-box/ExcludeOpportunityForm';
import ExclusionRenderer from '../../../../components/table-cells/ExclusionRenderer';
import ContactList from './ContactList';
import SubNav from '../../components/nav';

import {
  resetAll,
  fetchFeedbackExcludedOpportunities,
  loadSettings,
  winLossExcludeOpportunity,
} from '../../../Dashboard/DashboardActions';

import {
  getUser,
} from '../../../Auth/AuthReducer';

import {
  getExclusionLoading,
  getExclusionLoaded,
  getExclusionErrors,
  getExclusionOpportunities,
  getFeedbackRequestSettings,
} from '../../../Dashboard/DashboardReducer';

class ExclusionPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      selectedOpportunityIds: [],
      currentlyExcludedOpportunity: null,
      selectedTab: 'opportunities',
    };
    this.handleFormChange = this.handleFormChange.bind(this);
    this.requestEditExclusionReason = this.requestEditExclusionReason.bind(this);
    this.requestShowOpportunities = this.requestShowOpportunities.bind(this);
    this.handleExcludeOpportunity = this.handleExcludeOpportunity.bind(this);
    this.getColDefs = this.getColDefs.bind(this);
    this.onTabSelect = this.onTabSelect.bind(this);
  }

  requestEditExclusionReason(currentlyExcludedOpportunity, gridApi) {
    // console.clear();
    // console.log('opportunity', opportunity);
    // console.log('gridApi', gridApi);
    this.gridApi = gridApi;
    this.setState({ currentlyExcludedOpportunity })
  }


  handleExcludeOpportunity(opportunity, params) {
    const p = this.props.dispatch(winLossExcludeOpportunity(opportunity.opportunity_id, params));
    p.then(() => {
      // this.refreshData();
      // alert('refresh')
    });
    return p;
  }

  onTabSelect(selectedTab) {
    this.setState({ selectedTab });
  }


  requestShowOpportunities(selectedOpportunityIds) {
    this.setState({ selectedOpportunityIds });
  }

  componentDidMount() {
    this.props.dispatch(resetAll(false));
    this.setState({ loading: false });
    /*
    this.props.dispatch(fetchTVProductMappings())
      .then(
        () => {
          this.props.dispatch(fetchPrograms())
            .then(
              () => {
                this.setState({ loading: false });
              },
              () => {
                this.setState({ loading: false });
              },
            );
        }
      );
    */
  }

  getExcludedColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'exclusion.reason',
      enableRowGroup: true,
      enablePivot: true,
      cellRenderer: 'exclusionRenderer',
      cellRendererParams: {
        column,
        onRequestEdit: this.requestEditExclusionReason,
      },
    };
  }

  getColDefs(tableColumn) {
    if (tableColumn.tag === 'excluded') {
      return this.getExcludedColumn(tableColumn);
    }
    return null;
  }

  handleFormChange(criteria) {
    const {
      hasNoDecision,
    } = this.props;
    this.setState({ query: null, selectedFilter: null, selectedTab: 'opportunities' });
    this.props.dispatch(resetAll(false))
      .then(() => {
        this.setState({ tabs: {}, colorPalletes: {} });
        this.props.dispatch(loadSettings())
          .then(
            () => {
              this.props.dispatch(fetchFeedbackExcludedOpportunities({ ...criteria }, hasNoDecision))
                .then(
                  (results) => {
                    const { opportunities, total } = results;
                    const returnResults = opportunities.length;
                    if (total && returnResults < total) {
                      const el = (
                        <div>
                          Your search return more than <NumberDisplay value={total} precision={0} /> results.<br />
                          For optimal performance, only the latest <NumberDisplay value={returnResults} precision={0} /> will be displayed.
                        </div>
                      );
                      this.context.addNotification(el, { type: 'warning', autoClose: 30 * 1000 });
                    }
                  },
                  () => {
                    // TODO: handle error on search
                  },
                );
            },
            () => {
              // TODO: handle error on load settings
            },
          );
      });
  }


  renderResults() {
    const { opportunities, auth } = this.props;
    const { currentlyExcludedOpportunity } = this.state;
    if (opportunities.length === 0) {
      return (
        <div className="alert alert-warning">No results found.</div>
      );
    }
    return (
      <div>
        <ExclusionStats
          requestShowOpportunities={this.requestShowOpportunities}
        />

        <Tabs
          defaultActiveKey={this.state.selectedTab}
          id="outcome-tabs"
          animation
          mountOnEnter
          onSelect={this.onTabSelect}
        >
          <Tab
            eventKey="opportunities"
            title="Opportunities"
          >
            <div>
              <p />
              <OpportunityTable
                opportunities={opportunities}
                tableName="feedback-excluded-table"
                title={null}
                getColDefs={this.getColDefs}
                frameworkComponents={{
                  exclusionRenderer: ExclusionRenderer,
                }}
              />
            </div>
          </Tab>
          <Tab
            eventKey="contacts"
            title="Contacts"
          >
            <div>
              <p />
              <ContactList
                opportunities={this.props.opportunities}
              />
            </div>
          </Tab>
        </Tabs>


        <OpportunityModal
          opportunityIds={this.state.selectedOpportunityIds}
          getOpportunities={getExclusionOpportunities}
          tableConfigs={{
            tableName: 'feedback-excluded-table',
            getColDefs: this.getColDefs,
            frameworkComponents: {
              exclusionRenderer: ExclusionRenderer,
            },
          }}
          onClose={() => {
            this.setState({ selectedOpportunityIds: [] });
          }}
        />
        <ExcludeOpportunityForm
          opportunity={currentlyExcludedOpportunity}
          show={currentlyExcludedOpportunity !== null}
          onClose={() => { this.setState({ currentlyExcludedOpportunity: null }); }}
          requestExclude={this.handleExcludeOpportunity}
          auth={auth}
        />
      </div>
    );
  }

  render() {
    const {
      loaded, loading,
      feedbackRequestSettings,
    } = this.props;
    const isLoading = !loaded || loading;

    const includeOpenOpportunities = feedbackRequestSettings.include_open_opportunities === true;


    const topComponent = (
      <div className="clearfix">
        <div className="pull-left">
          <SubNav />
        </div>
        {!this.state.loading &&
          <div className="pull-right">
            <SearchForm
              onSearchChange={this.handleFormChange}
              onReset={this.hanldeReset}
              pullRight
              requireTeamSelector={false}
              selectDefaultTeam
              source="account"
              type="feedback/exclusions"
              defaultCriteria={{
                type: 'groupAND',
                values: [
                  {
                    tag: 'closeDate',
                    type: 'include',
                    values: 'last-90-days',
                  },
                ],
              }}
              disabledFilters={[]}
              disabled={isLoading}
            >
              {includeOpenOpportunities &&
                <IncludeOpenOpportunities
                  path={1}
                  level={1}
                  includeOpenOpportunities={includeOpenOpportunities}
                  showDelete={false}
                  showInclude={false}
                  searchCriteria={{
                    _id: 'open-opportunities',
                    type: 'include',
                    filter: {
                      _id: 'open-opportunities',
                      label: 'Open Opportunities',
                    },
                  }}
                />
              }
            </SearchForm>
          </div>
        }
      </div>
    );

    return (
      <div className="container">
        <Helmet title="Exclusions | Feedback" />
        <div>{topComponent}</div>
        <p/ >
        <div>
          {(isLoading || this.state.loading) && <div><ProgressBar /></div>}
          {!(isLoading || this.state.loading) && this.renderResults()}
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    loading: getExclusionLoading(state),
    loaded: getExclusionLoaded(state),
    errors: getExclusionErrors(state),
    opportunities: getExclusionOpportunities(state),
    feedbackRequestSettings: getFeedbackRequestSettings(state),
    auth: getUser(state),
  };
}

ExclusionPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  errors: PropTypes.shape({}),
  opportunities: PropTypes.arrayOf(PropTypes.shape({})),
  feedbackRequestSettings: PropTypes.shape({
    include_open_opportunities: PropTypes.bool,
  }),
  auth: PropTypes.shape({}).isRequired,
};

ExclusionPage.defaultProps = {
  loading: false,
  loaded: false,
  errors: null,
  opportunities: [],
  feedbackRequestSettings: {
    include_open_opportunities: false,
  },
};

ExclusionPage.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};
export default connect(mapStateToProps)(withRouter(ExclusionPage));
